import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { map, switchMap } from "rxjs/operators";
import { FilerInformationService } from "..";
import { FinancialDisclosureService } from "../api-services/fianancial-disclosure.service";

export const CandidateSEIRequiredGuard: CanActivateFn = () => {
    const filer = inject(FilerInformationService);
    const ethicsService = inject(FinancialDisclosureService);

    return filer.current$.pipe(
        switchMap((x) =>
            ethicsService.getEthicFilingPeriods(true, x?.electionCycleId ?? 0)
        ),
        map((x) => x.length > 0)
    );
};
